export function dateToLocal(dateString): Date {
    var substring = dateString.toString().substring(0, 19);
    var year = parseInt(substring.substring(0,4));
    var month = parseInt(substring.substring(5,7)) - 1;
    var day = parseInt(substring.substring(8,10));
    var hour = parseInt(substring.substring(11,13) === "" ? 0 : substring.substring(11,13));
    var minute = parseInt(substring.substring(14,16) === "" ? 0 : substring.substring(14,16));
    var second = parseInt(substring.substring(17) === "" ? 0 : substring.substring(17));
    return new Date(Date.UTC(year, month, day, hour, minute, second));
}

export function dateToUTC(dateString: Date): string {
    return dateString.toUTCString();
}

export const handleError = (apiError) => {
    try{
        var errorBody = JSON.parse(apiError.body)
        var errors = errorBody.errors
        var errorString;
        if(errors) {
            errorString = Object.keys(errors).map(errorKey => {
                return errors[errorKey].join('\n');
            }).join('\n')
        } else {
            errorString = errorBody.title;
        }
        alert(errorString)
    }
    catch{
        alert(apiError.message)
    }
}

export const handleErrorToast = (apiError) => {
    try{
        var errorBody = JSON.parse(apiError.body)
        var errors = errorBody.errors
        var errorString;
        if(errors) {
            errorString = Object.keys(errors).map(errorKey => {
                return errors[errorKey].join('\n');
            }).join('\n')
        } else {
            errorString = `${errorBody.title}: ${errorBody.detail ?? ""}`;
        }
        return errorString;
    }
    catch{
        return apiError.message;
    }
}

export const formatMoney = (money) => {
    //this will allow us to change formatting if we need foreign currency.
    var formatter = new Intl.NumberFormat('en-US', {// undefined uses system locale
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(money);
}

export function storeData(title: string, data: any) {
    sessionStorage.setItem(title, JSON.stringify(data));
}

export function retrieveData(title: string): any {
    let dataString = sessionStorage.getItem(title);
    return dataString ? JSON.parse(dataString) : null;
}

export function removeData(title: string) {
    sessionStorage.removeItem(title);
}

export function isAdmin(): boolean {
    return retrieveData("token") !== null;
}

export function remainingTime (time: Date) {
    const millisRemaining = time.getTime() - Date.now();
    return Math.abs(millisRemaining-1000);
}

export function getBacchusURL(): string {
    return `${process.env.REACT_APP_BACCHUS_HOST}`;
    //return "https://localhost:3001"; //local testing only
}

export const isProd = () => {
    const env = process.env.REACT_APP_ENV_NAME?.toLowerCase();
    return env === "production";
}